import { Form, Input, Modal, Select } from 'antd';
import Button from 'mixins/ui/button/button';
import React, { FC, useEffect } from 'react';
import {
    ApiTokenRequestDto,
    ApiTokenRequestStatus,
    ChangeApiTokenRequestStatusData,
} from '../types';
import {
    API_TOKEN_REQUEST_STATUS_LABELS,
    EDITABLE_API_TOKEN_REQUEST_STATUSES,
} from '../utils/constants';

interface TokenRequestStatusModalProps {
    visible: boolean;
    request?: ApiTokenRequestDto | null;
    initialStatus?: Exclude<ApiTokenRequestStatus, 'TOKEN_ISSUED'>;
    loading: boolean;
    onCancel: () => void;
    onSubmit: (data: ChangeApiTokenRequestStatusData) => void;
}

export const TokenRequestStatusModal: FC<TokenRequestStatusModalProps> = ({
    visible,
    request,
    initialStatus,
    loading,
    onCancel,
    onSubmit,
}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (!visible || !request) {
            return;
        }

        form.setFieldsValue({
            status:
                initialStatus ||
                (request.status === 'TOKEN_ISSUED' ? undefined : request.status),
            adminComment: request.adminComment || '',
        });
    }, [form, initialStatus, request, visible]);

    const submit = () => {
        if (!request) {
            return;
        }

        form.validateFields().then((values) => {
            onSubmit({
                id: request.id,
                status: values.status,
                adminComment: values.adminComment,
            });
        });
    };

    return (
        <Modal
            title="Изменение статуса заявки"
            visible={visible}
            onCancel={onCancel}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Отменить
                </Button>,
                <Button key="save" onClick={submit} loading={loading}>
                    Сохранить
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="Статус"
                    name="status"
                    rules={[
                        {
                            required: true,
                            message: 'Выберите статус заявки',
                        },
                    ]}
                >
                    <Select size="large" placeholder="Выберите статус">
                        {EDITABLE_API_TOKEN_REQUEST_STATUSES.map((status) => (
                            <Select.Option key={status} value={status}>
                                {API_TOKEN_REQUEST_STATUS_LABELS[status]}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item label="Комментарий администратора" name="adminComment">
                    <Input.TextArea
                        rows={4}
                        maxLength={2000}
                        placeholder="Введите комментарий"
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};